var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:`icon icon-${_vm.icon}`},[_c('use',{attrs:{"href":_vm.svgUrl,"xlink:href":_vm.svgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }